<section class="app-shell">
    <main class="workspace">
        <header class="page-header">
            <div class="title-group">
                <button class="back-button">‹</button>

                <div class="asset-avatar" aria-hidden="true">
                    <span></span>
                </div>

                <div>
                    <div class="title-row">
                        <h1>Hodgson Capital Partners</h1>
                        <span class="status-pill">Closed-end fund</span>
                    </div>

                    <nav class="top-tabs" aria-label="Investment sections">
                        <button
                                *ngFor="let tab of tabs; let i = index"
                                class="tab"
                                [class.active]="i === 0"
                        >
                            {{ tab }}
                        </button>
                    </nav>
                </div>
            </div>

            <div class="header-actions">
                <button class="primary-button">▣ New transaction</button>
                <button class="dark-button">＋ Property</button>
                <button class="icon-button">✎</button>
                <button class="icon-button">▧</button>
                <button class="icon-button borderless">⋮</button>
            </div>
        </header>

        <div class="page-body">
            <aside class="section-menu">
                <div class="tag-link">Add Tags +</div>

                <button
                        *ngFor="let link of sideLinks; let i = index"
                        [class.active]="i === 0"
                >
                    {{ link }}
                </button>
            </aside>

            <section class="content">
                <div class="tag-link mobile">Add Tags +</div>

                <section class="card summary-card">
                    <div class="summary-heading">
                        <span>NAV</span>
                        <strong>5,013,855</strong>
                        <span>EUR</span>
                    </div>

                    <div class="metric-grid">
                        <div class="currency-labels">
                            <span>EUR</span>
                            <span>CHF</span>
                        </div>

                        <div class="metric" *ngFor="let metric of summaryMetrics">
                            <span>{{ metric.label }}</span>
                            <strong>{{ metric.value }}</strong>
                            <strong *ngIf="metric.subValue">{{ metric.subValue }}</strong>
                        </div>
                    </div>
                </section>

                <section class="card chart-card">
                    <div class="card-header">
                        <h2>J-Curve</h2>

                        <div class="chart-actions">
                            <button>At date</button>
                            <button>Forecast</button>
                        </div>
                    </div>

                    <div
                            class="chart-wrap"
                            role="img"
                            aria-label="J-Curve chart showing cumulative cashflow, NAV, and cumulative profit and loss over time"
                    >
                        <svg viewBox="0 0 1000 240" preserveAspectRatio="none">
                            <defs>
                                <linearGradient id="navFill" x1="0" x2="0" y1="0" y2="1">
                                    <stop offset="0%" stop-color="#1d9bd7" stop-opacity="0.24" />
                                    <stop offset="100%" stop-color="#1d9bd7" stop-opacity="0.02" />
                                </linearGradient>

                                <linearGradient id="forecastFill" x1="0" x2="1" y1="0" y2="0">
                                    <stop offset="0%" stop-color="#9eb5c6" stop-opacity="0.16" />
                                    <stop offset="100%" stop-color="#9eb5c6" stop-opacity="0.22" />
                                </linearGradient>
                            </defs>

                            <rect
                                    class="forecast-band"
                                    x="640"
                                    y="10"
                                    width="310"
                                    height="168"
                                    fill="url(#forecastFill)"
                            ></rect>

                            <g class="grid-lines">
                                <g *ngFor="let tick of yTicks">
                                    <line
                                            [attr.x1]="72"
                                            [attr.x2]="976"
                                            [attr.y1]="y(tick)"
                                            [attr.y2]="y(tick)"
                                    ></line>

                                    <text [attr.x]="18" [attr.y]="y(tick) + 4">
                                        {{ formatTick(tick) }}
                                    </text>
                                </g>
                            </g>

                            <line
                                    class="zero-line"
                                    x1="72"
                                    x2="976"
                                    [attr.y1]="y(0)"
                                    [attr.y2]="y(0)"
                            ></line>

                            <polygon
                                    class="nav-area"
                                    [attr.points]="areaPoints('nav')"
                            ></polygon>

                            <polyline
                                    class="line cashflow"
                                    [attr.points]="linePoints('cashflow')"
                            ></polyline>

                            <polyline
                                    class="line nav"
                                    [attr.points]="linePoints('nav')"
                            ></polyline>

                            <polyline
                                    class="line pnl"
                                    [attr.points]="linePoints('pnl')"
                            ></polyline>

                            <g *ngFor="let point of chartData; let i = index">
                                <line
                                        class="x-tick"
                                        [attr.x1]="x(i)"
                                        [attr.x2]="x(i)"
                                        y1="178"
                                        y2="184"
                                ></line>

                                <text class="x-label" [attr.x]="x(i)" y="218">
                                    {{ point.period }}
                                </text>

                                <circle
                                        class="dot cashflow"
                                        [attr.cx]="x(i)"
                                        [attr.cy]="y(point.cashflow)"
                                        r="3"
                                ></circle>

                                <circle
                                        class="dot nav"
                                        [attr.cx]="x(i)"
                                        [attr.cy]="y(point.nav)"
                                        r="3"
                                ></circle>

                                <circle
                                        class="dot pnl"
                                        [attr.cx]="x(i)"
                                        [attr.cy]="y(point.pnl)"
                                        r="3"
                                ></circle>
                            </g>
                        </svg>
                    </div>

                    <div class="legend">
                        <span><i class="cashflow"></i>Cum. Cashflow</span>
                        <span><i class="nav"></i>NAV</span>
                        <span><i class="pnl"></i>Cum. P/L</span>
                    </div>
                </section>

                <section class="card facts-card">
                    <h2>Facts</h2>

                    <div class="facts-grid">
                        <div *ngFor="let item of factItems">
                            <span>{{ item.label }}</span>
                            <strong>{{ item.value }}</strong>
                        </div>
                    </div>
                </section>

                <section class="card table-card">
                    <div class="card-header">
                        <h2>Linked investments</h2>
                        <button class="filter-button">Export ▾</button>
                    </div>

                    <div class="table-wrapper">
                        <table>
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Currency</th>
                                <th>Value</th>
                                <th>Commitment</th>
                                <th>Exposure</th>
                                <th>Status</th>
                                <th></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr *ngFor="let row of securityRows">
                                <td>{{ row.name }}</td>
                                <td>{{ row.type }}</td>
                                <td>{{ row.currency }}</td>
                                <td>{{ row.value }}</td>
                                <td>{{ row.commitment }}</td>
                                <td>{{ row.exposure }}</td>
                                <td>
                                    <span class="table-status">{{ row.status }}</span>
                                </td>
                                <td>
                                    <button class="row-button">⌕</button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </section>
            </section>
        </div>
    </main>
</section>
